<template>
    <div class="MultiToggle-Wrapper">
        <a  v-for=" (ButtonList ,index) in ButtonList" :key="index" ref="Buttons"
            href="#" :t_label="`EMPBE_Captions_${ButtonList.Id}`"
            :class="{
                'Active': IsSelected(ButtonList.Id),
                'disabled': disabled
            }"
            @click="ToggleCaption(ButtonList.Id, index)"
            > {{ ButtonList.Text }}</a>
    </div>

</template>

<script>
export  default{
    props:["ButtonList","SelectedId","Max","value", "disabled"],
    emits: ['input'],
    data(){
        return{
            LocalSelected : this.SelectedId ? this.SelectedId : [],
            IsLimitQuantity: this.Max ? true : false,
        }
    },
    computed:{

    },
    methods:{
        ToggleCaption(Id,index){
            if(this.disabled){
                return;
            }

            if(this.IsSelected(Id)){
                //De-Select
                
                this.LocalSelected = this.LocalSelected.filter(x => x !== Id)       
            }
            else{
                //Select
                if(!this.IsLimitQuantity || this.LocalSelected.length < this.Max){
                    
                    this.LocalSelected.push(Id)
                }   
            }
            
            //emit local selected value to parent (But WTF? why v-model binded to 'input' instead of 'update:modelValue' stated in Vue doc?)
            this.$emit('input', this.LocalSelected);

        },

        IsSelected(Id){
            return this.LocalSelected.includes(Id);
        }
    },
    watch:{
        SelectedId(){
            this.LocalSelected =  this.SelectedId;
        }
    }
}
</script>

<style lang="scss">
    .MultiToggle-Wrapper{
        display: flex;
        padding-bottom: 8px;
        align-items: flex-start;
        align-content: flex-start;
        gap: 8px; /* change this to adjust the gap of the buttons*/ 
        align-self: stretch;
        flex-wrap: wrap;

        a{
            padding: 8px 16px;
            border-radius: 999px;
            border: 1px solid rgba(0, 0, 0, 0.23);

            &.Active{
                background: #7366FF;
                color:white;
                font-weight: 700;
            }

            &.disabled{
                cursor: not-allowed;
            }
        }
    }
</style>